<template>
  <v-container class="d-flex align-center justify-center" fluid>
    <v-row>
      <v-col cols="12" md="6" class="mx-auto">
        <v-card elevation="2" class="pa-6">
          <v-card-title class="text-h5 text-center mb-4">Register</v-card-title>

          <v-form @submit.prevent="handleRegister">
            <v-text-field
              v-model="name"
              label="Full Name"
              type="text"
              required
              prepend-inner-icon="mdi-account"
            ></v-text-field>

            <v-text-field
              v-model="email"
              label="Email"
              type="email"
              required
              prepend-inner-icon="mdi-email"
            ></v-text-field>

            <v-text-field
              v-model="password"
              label="Password"
              type="password"
              required
              prepend-inner-icon="mdi-lock"
            ></v-text-field>

            <v-btn type="submit" color="primary" block class="mb-2">Register</v-btn>

            <div class="text-center mt-2">
              <router-link to="/login" class="text-caption text-decoration-none">
                Already have an account?
              </router-link>
            </div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'RegisterView',
  data() {
    return {
      name: '',
      email: '',
      password: ''
    }
  },
  methods: {
    handleRegister() {
      localStorage.setItem('isLoggedIn', 'true')
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>

</style>
